export default "__VITE_ASSET__DNrEfSas__"